import { SVGProps, Ref, forwardRef } from 'react';

export const LivejournalSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.693 2.415c-1.452 0-2.831.302-4.092.847L6.338 1A10.33 10.33 0 0 0 1 6.364l2.263 2.262a10.2 10.2 0 0 0-.862 4.089 10.29 10.29 0 0 0 6.364 9.505 10.31 10.31 0 0 0 11.223-2.24 10.29 10.29 0 0 0-1.572-15.834 10.3 10.3 0 0 0-5.723-1.731m4.291 9.21L8.608 3.262a10.33 10.33 0 0 0-5.345 5.364l8.383 8.362a10.34 10.34 0 0 1 5.338-5.363m.592 2.853.005.005-.001-.007h.001l.811 3.926-3.908-.81a6.02 6.02 0 0 1 3.092-3.114"
            fill="currentColor"
        />
    </svg>
));
LivejournalSolidSize24Glyph.displayName = 'LivejournalSolidSize24Glyph';
